import { memo, createContext, useState, useEffect } from "react";

export const ScreenContext = createContext();

const ScreenProvider = memo((props) => {
  const [screen, setScreen] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    heightOuter: window.outerHeight,
    isDesktop: window.innerWidth > 767 ? true : false,
  });

  const resizeWindow = () => {
    setScreen({
      width: window.innerWidth,
      isDesktop: window.innerWidth > 767 ? true : false,
    });

    // add class in body {desktop}
    if (window.innerWidth > 767) {
      document.body.classList.add("desktop");
    } else {
      document.body.classList.remove("desktop");
    }
  };

  useEffect(() => {
    // add class in body {desktop}
    if (window.innerWidth > 767) {
      document.body.classList.add("desktop");
    } else {
      document.body.classList.remove("desktop");
    }
    // end add class in body {desktop}

    window.addEventListener("resize", resizeWindow);

    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  return (
    <>
      <ScreenContext.Provider
        value={{
          screen,
        }}
      >
        {props?.children}
      </ScreenContext.Provider>
    </>
  );
});

export default ScreenProvider;
